// --
// -- Hand a file the browser already has to the person using it.
// --
// -- Fetched through the API layer rather than linked to directly: the session
// -- is an httpOnly cookie on another origin, and a plain link would miss the
// -- refresh-on-401 that every other request gets - the download would just
// -- fail once the access token aged out.
// --
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();
  link.remove();

  // -- Revoked on the next tick, not immediately: some browsers have not
  // -- started reading the blob by the time click() returns.
  setTimeout(() => URL.revokeObjectURL(url), 0);
};
